import { render, staticRenderFns } from "./VehicleReportTable.vue?vue&type=template&id=5847d77f&scoped=true"
import script from "./VehicleReportTable.vue?vue&type=script&lang=js"
export * from "./VehicleReportTable.vue?vue&type=script&lang=js"
import style0 from "./VehicleReportTable.vue?vue&type=style&index=0&id=5847d77f&prod&lang=css"
import style1 from "./VehicleReportTable.vue?vue&type=style&index=1&id=5847d77f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5847d77f",
  null
  
)

export default component.exports